import {
  Box,
  Button,
  CircularProgress,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { gql, useMutation } from "@apollo/client";
import {
  Link as RouterLink,
  useLocation,
  useNavigate,
} from "react-router-dom";
import FlashMessage from "../../components/FlashMessage";
import Analytics from "../../utils/analytics";
import { isValidEmailAddress } from "../../utils/customFunction";
import useStyles from "./styles";
import ForgotPassIcon from "../../assets/images/logo.png";
import { LoginWrapper } from "../Wrapper";
import { forgotPassword } from "../../apollo/server";

const FORGOT_PASSWORD = gql`${forgotPassword}`;

function ForgotPassword(props) {
  const formRef = useRef();
  const theme = useTheme();
  const classes = useStyles();
  const { state } = useLocation();
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [emailError, setEmailError] = useState("");

  const [sendForgot, { loading }] = useMutation(FORGOT_PASSWORD, {
    onCompleted: () => {
      const emailValue = formRef.current["userEmail"].value;
      navigate("/verify-forgot-otp", {
        replace: true,
        state: { email: emailValue, skipInitialSend: true },
      });
    },
    onError: (e) => {
      const msg = e.graphQLErrors?.[0]?.message || e.message || "Could not send code";
      setError(msg);
    },
  });

  const clearErrors = () => {
    setEmailError("");
    setError("");
  };
  const handleAction = () => {
    clearErrors();
    const emailValue = formRef.current["userEmail"].value;
    if (!isValidEmailAddress(emailValue)) {
      setEmailError("Invalid Email");
      return;
    }
    sendForgot({ variables: { email: emailValue.toLowerCase().trim() } });
  };
  useEffect(() => {
    const fetchTrack = async () => {
      await Analytics.track(Analytics.events.NAVIGATE_TO_FORGOT_PASSWORD);
    };
    fetchTrack();
  }, []);
  const toggleSnackbar = useCallback(() => {
    setError("");
  }, []);

  return (
    <LoginWrapper>
      <FlashMessage
        open={Boolean(error)}
        severity={"error"}
        alertMessage={error}
        handleClose={toggleSnackbar}
      />
      <Box display="flex" justifyContent="center">
        <img
          src={ForgotPassIcon}
          alt="RushMyFood"
          style={{ width: 140, height: "auto", objectFit: "contain" }}
        />
      </Box>
      <form ref={formRef}>
        <Box mt={theme.spacing(2)} />
        <Typography variant="h5" className={classes.font700}>
          Forgot your password?
        </Typography>
        <Box mt={theme.spacing(2)} />
        <Typography
          variant="caption"
          className={`${classes.caption} ${classes.fontGrey}`}
        >
          Enter your email and we'll send you a 6-digit code to reset your password
        </Typography>
        <Box mt={theme.spacing(2)} />
        <TextField
          name={"userEmail"}
          defaultValue={state?.email ?? ""}
          error={Boolean(emailError)}
          helperText={emailError}
          fullWidth
          variant="outlined"
          label="Email"
          InputLabelProps={{
            style: {
              color: theme.palette.grey[600],
            },
          }}
        />
        <Box mt={theme.spacing(8)} />
        <Button
          variant="contained"
          color="primary"
          fullWidth
          type="email"
          disableElevation
          disabled={loading}
          className={classes.btnBase}
          onClick={(e) => {
            e.preventDefault();
            handleAction();
          }}
        >
          {loading ? (
            <CircularProgress size={20} sx={{ color: "#fff" }} />
          ) : (
            <Typography
              variant="caption"
              className={`${classes.caption} ${classes.font700}`}
            >
              Send Code
            </Typography>
          )}
        </Button>
        <Box mt={theme.spacing(2)} />
        <RouterLink to="/login-email" style={{ textDecoration: "none" }}>
          <Button>
            <Typography
              variant="caption"
              color="primary"
              style={{
                textTransform: "none",
              }}
              className={classes.font700}
            >
              Back to login
            </Typography>
          </Button>
        </RouterLink>
      </form>
    </LoginWrapper>
  )
}

export default ForgotPassword;
